export const Spinner = ({ size = 16 }: { size?: number }) => (
  <span
    className="inline-block shrink-0 animate-spin-fast rounded-full border-2 border-brand-bg/30"
    style={{ width: size, height: size, borderTopColor: '#060b19' }}
  />
);

export const RingSpinner = ({ size = 40 }: { size?: number }) => (
  <span
    className="inline-block animate-spin-fast rounded-full border-2 border-brand-teal/15"
    style={{ width: size, height: size, borderTopColor: '#46c0ba' }}
  />
);
